// extracted by mini-css-extract-plugin
export default {"MobileHeader":"mobile-header_MobileHeader__frv7Q","LogoBlock":"mobile-header_LogoBlock__kopmG","languageBlok":"mobile-header_languageBlok__C66EH"};